// Third-party libraries
import { TranslationService } from '@/utils/services';

// Hooks
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Utils
import useStateWithReset from '@/utils/hooks/utils/useStateWithReset';

import { HOME } from '@/lib/routes/privateRoutes';

// Components
import InfoBanner from '@/components/base/InfoBanner/CompoundBanner';
// Layouts
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import ContactContainer from '@/components/pages/home/ContactContainer';
import HomeHeader from '@/components/pages/home/header/Header';
import { HomeKeyActions } from '@/components/pages/home/keyActions';
import KeyNumbers from '@/components/pages/home/keyNumbers';
import BlogPosts from '@/components/pages/home/newsArticles/BlogPosts';
import FAQArticles from '@/components/pages/home/newsArticles/FAQArticles';
import NewFeature from '@/components/pages/home/newsArticles/NewFeature';

function HomeContent() {
    const { user } = useUser();
    const { t: tHome } = useTranslation('home');
    const { t: tCommons } = useTranslation('commons');

    const [error, setError, resetError] = useStateWithReset<string>(null);

    const isTrial = user?.trial;

    return (
        <>
            <div className="mb-9 @container">
                <HomeHeader setError={setError} />
                {error ? (
                    <InfoBanner className="mt-8">
                        <InfoBanner.Icon />
                        <InfoBanner.Content title={tCommons('error')} message={error} />
                        <InfoBanner.Close onClose={resetError} />
                    </InfoBanner>
                ) : null}
                <HomeKeyActions />
                {isTrial ? <ContactContainer /> : null}
                <h2 className="mt-8 font-GBold text-3xl">{tHome('key_numbers.title')}</h2>
                <p className="my-2 text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                    {tHome('key_numbers.text')}
                </p>
                <KeyNumbers />
                <h2 className="my-8 font-GBold text-3xl">
                    {tHome('latest_news_and_articles_from_iconosquare')}
                </h2>
                <div className="grid grid-cols-4 gap-5">
                    <NewFeature />
                    <FAQArticles />
                </div>
                <div className="mt-11 grid grid-cols-1 gap-5 @lg:grid-cols-2 @4xl:grid-cols-3">
                    <BlogPosts />
                </div>
            </div>
            {!isTrial ? <ContactContainer withG2Review /> : null}
        </>
    );
}

const Home = () => {
    return (
        <WrapperSwitchLayout>
            <HomeContent />
        </WrapperSwitchLayout>
    );
};

export const getStaticProps = TranslationService.getTranslationMessagesFromRoute(HOME);

export default Home;
